import { useState, useEffect } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import * as styled from "./LessonPayment.styled";
import { getAllStudents } from "../../../helpers/getAllStudents";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import PaymentsSummary from "../../../components/PaymentsSummary/PaymentsSummary";
import { packagePricesFor } from "../../../helpers/langs";

// Пакети й ціни — як на сайті, свої для кожної мови (helpers/langs.js); суму можна змінити перед підтвердженням (знижка, акція)

function LessonPayment({ adminInfo }) {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [status, setStatus] = useState({ success: null, id: null });
  const [search, setSearch] = useState("");
  const [pending, setPending] = useState(null); // { id, lessons, amount }
  const [refreshKey, setRefreshKey] = useState(0);
  // Учні на паузі за замовчуванням сховані; вибір запамʼятовуємо в браузері
  const [showPaused, setShowPaused] = useState(() => {
    try { return window.localStorage.getItem("payments.showPaused") === "1"; } catch { return false; }
  });
  const toggleShowPaused = () => {
    setShowPaused((v) => {
      try { window.localStorage.setItem("payments.showPaused", v ? "0" : "1"); } catch {}
      return !v;
    });
  };
  const navigate = useNavigate();

  const getStudents = () => {
    getAllStudents().then((students) => {
      const filtered = students.map(
        ({
          _id,
          name,
          totalLessons,
          studentId,
          ageGroup,
          accessType,
          lessonPackage,
          isPaused,
        }) => ({
          _id,
          name,
          totalLessons,
          studentId,
          ageGroup,
          accessType,
          lessonPackage,
          isPaused,
        })
      );
      setStudents(filtered);
      setFilteredStudents(filtered);
    });
  };
  useEffect(() => {
    getStudents();
  }, []);

  useEffect(() => {
    const searchTerm = search.toLowerCase();
    setFilteredStudents(
      students.filter(
        ({ name, studentId, accessType, isPaused }) =>
          (showPaused || !isPaused) &&
          (adminInfo.accessType === "all" ||
            accessType === adminInfo.accessType) &&
          (name.toLowerCase().includes(searchTerm) ||
            studentId.toLowerCase().includes(searchTerm))
      )
    );
  }, [search, students, adminInfo.accessType, showPaused]);

  const updatePackage = async (lessons, id) => {
    try {
      await axios.post(`students/update-total/${id}/${lessons}`);
      setStatus({ success: true, id });
      getStudents();
      setSelectedId(null);
      setTimeout(() => setStatus({ success: null, id: null }), 2000);
    } catch {
      setStatus({ success: false, id });
      setTimeout(() => setStatus({ success: null, id: null }), 2000);
    }
  };

  // ±1 — ручна корекція (пишеться в історію). Борг (відʼємний баланс) не обнуляємо.
  const handleChangeByOne = async (id, delta) => {
    const student = students.find((s) => s._id === id);
    if (!student) return;
    await updatePackage(student.totalLessons + delta, id);
  };

  // Оплата пакета: уроки ДОДАЮТЬСЯ до залишку, оплата пишеться в історію
  const confirmPayment = async () => {
    if (!pending) return;
    const { id, lessons, amount } = pending;
    try {
      await axios.post(`students/${id}/payment`, { lessons, amount: Number(amount) });
      setStatus({ success: true, id });
      setPending(null);
      setSelectedId(null);
      getStudents();
      setRefreshKey((k) => k + 1);
      setTimeout(() => setStatus({ success: null, id: null }), 2000);
    } catch {
      setStatus({ success: false, id });
      setTimeout(() => setStatus({ success: null, id: null }), 2000);
    }
  };

  return (
    <PagesWrapper>
      <TopPageTitle value={"Оплата учнів"} />
      <PaymentsSummary refreshKey={refreshKey} accessType={adminInfo.accessType} />
      <styled.TopWrapper>
        <styled.SearchInput
          placeholder="Пошук за ім'ям або ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <styled.TotalStudents>
          {
            filteredStudents.filter(
              ({ isTest, isPaused }) =>
                !isTest &&
                (isPaused === undefined || isPaused === false)
            ).length
          }{" "}
          students
        </styled.TotalStudents>
        <styled.PausedToggle type="button" $on={showPaused} onClick={toggleShowPaused} aria-pressed={showPaused}>
          {showPaused ? "✓ " : ""}Учні на паузі ({students.filter((s) => s.isPaused && (adminInfo.accessType === "all" || s.accessType === adminInfo.accessType)).length}): {showPaused ? "показані" : "сховані"}
        </styled.PausedToggle>
      </styled.TopWrapper>

      <styled.PaymentContainer>
        {filteredStudents
          .sort((a, b) => a.totalLessons - b.totalLessons)
          .map(
            ({
              _id,
              name,
              studentId,
              totalLessons,
              ageGroup,
              lessonPackage,
              isPaused,
              accessType,
            }) => {
              const isOpen = selectedId === _id;
              const prices = packagePricesFor(accessType);

              return (
                <styled.StudentPaymentCard
                  key={_id}
                  isTotalZero={totalLessons <= 0}
                  colorLevel={
                    totalLessons <= 0
                      ? "low"
                      : totalLessons <= 1
                      ? "medium"
                      : "high"
                  }
                  isPaused={isPaused}
                  animate={status.id === _id}
                  onClick={() => setSelectedId(isOpen ? null : _id)}
                >
                  <styled.Header>
                    <styled.StudentName>{name}</styled.StudentName>
                    <styled.MoveItem
                      onClick={() =>
                        navigate(`/admin/ourstudents/${ageGroup}/${_id}`)
                      }
                    >
                      Переглянути
                    </styled.MoveItem>
                  </styled.Header>
                  <styled.StudentID>ID: {studentId}</styled.StudentID>
                  {isPaused && (
                    <styled.StudentID>Призупинив заняття</styled.StudentID>
                  )}

                  <styled.ProgressBarContainer>
                    <styled.ProgressBar
                      value={totalLessons}
                      max={lessonPackage || 50}
                    />
                    <span>{totalLessons} занять</span>
                  </styled.ProgressBarContainer>

                  <styled.Actions>
                    <styled.ChangeButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleChangeByOne(_id, -1);
                      }}
                    >
                      -1
                    </styled.ChangeButton>
                    <styled.ChangeButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleChangeByOne(_id, 1);
                      }}
                    >
                      +1
                    </styled.ChangeButton>
                  </styled.Actions>

                  {isOpen && pending?.id !== _id && (
                    <styled.PackagesList>
                      {Object.keys(prices).map(Number).map((val) => (
                        <styled.PackageButton
                          key={val}
                          onClick={(e) => {
                            e.stopPropagation();
                            setPending({ id: _id, lessons: val, amount: prices[val] });
                          }}
                        >
                          {val} уроків
                        </styled.PackageButton>
                      ))}
                    </styled.PackagesList>
                  )}

                  {pending?.id === _id && (
                    <styled.ConfirmBox onClick={(e) => e.stopPropagation()}>
                      <span>
                        Оплата {pending.lessons} уроків: залишок {totalLessons} → <b>{totalLessons + pending.lessons}</b>
                      </span>
                      <label>
                        Сума, грн
                        <styled.AmountInput
                          type="number"
                          min="0"
                          value={pending.amount}
                          onChange={(e) => setPending({ ...pending, amount: e.target.value })}
                        />
                      </label>
                      <styled.ConfirmActions>
                        <styled.PackageButton onClick={confirmPayment}>Підтвердити оплату</styled.PackageButton>
                        <styled.ChangeButton onClick={() => setPending(null)}>Скасувати</styled.ChangeButton>
                      </styled.ConfirmActions>
                    </styled.ConfirmBox>
                  )}

                  {status.id === _id && status.success === true && (
                    <styled.SuccessText>✅ Успішно оновлено</styled.SuccessText>
                  )}
                  {status.id === _id && status.success === false && (
                    <styled.ErrorText>❌ Помилка оновлення</styled.ErrorText>
                  )}
                </styled.StudentPaymentCard>
              );
            }
          )}
      </styled.PaymentContainer>
    </PagesWrapper>
  );
}

export default LessonPayment;
